import PropTypes from 'prop-types';
import { ObjectPropsPropType } from '../../../services/proptypes';
export var BLUR_IN_TRANSITION = 'blurIn';
export var BLUR_OUT_TRANSITION = 'blurOut';
export var HEIGHT_TRANSITION = 'height';
export var BLUR_ANIMATION = 'blur';
export var SLIDE = 'slide';
export var FADE = 'fade';
export var Transition = PropTypes.oneOf([BLUR_IN_TRANSITION, BLUR_OUT_TRANSITION, HEIGHT_TRANSITION]);
export var AnimationName = PropTypes.oneOf([BLUR_ANIMATION]);
export var TransitionProps = PropTypes.shape({
  preAnimating: ObjectPropsPropType,
  animating: ObjectPropsPropType
});
export var Animation = PropTypes.shape({
  name: AnimationName.isRequired,
  duration: PropTypes.number,
  transitionProps: TransitionProps
});